import React from 'react';
import Footer from './Footer';
import { generateFooters } from '../../utils/react-utils';

export interface ProxyFooterProps {
  text?: React.ReactNode;
  footerLinks: JQuery;
  alwaysDisplayBackToSignIn: boolean;
  additionalOnClick?: () => void;
}

export default function ProxyFooter({
  text,
  footerLinks,
  alwaysDisplayBackToSignIn,
  additionalOnClick,
}: ProxyFooterProps) {
  const reactFooters = generateFooters({ footerLinks, alwaysDisplayBackToSignIn, additionalOnClick });
  return <Footer footerText={text} reactFooters={reactFooters} />;
}
